import React from "react";
import { Helmet } from "react-helmet-async";
import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";
import TabPanel from "../../elements/tab/materialTabPanel";
import RatesContainer from "./RatesContainer";
import { useHistory } from "react-router-dom";
import queryString from "query-string";
import { useTranslation } from "react-i18next";

import { StyledTabsBody, StyledTabsHead, StyledTabsWrapper } from "../../styles/styledTabs";

const DEFAULT_TAB = "currency";

const RatesTabsContainer = ({ match }) => {
  const { t } = useTranslation("ratesPage");
  const history = useHistory();
  let queryParams = queryString.parse(history.location.search);

  const urlForTabs = () => {
    if (!queryParams.currentTab) {
      return 0;
    }

    switch (queryParams.currentTab) {
      case "currency": {
        return 0;
      }
      case "crypto": {
        return 1;
      }
    }
  };

  const tabValue = urlForTabs();

  const handleChange = (event, newValue) => {
    if (queryParams.currentTab !== newValue) {
      history.push("?currentTab=" + newValue);
    }
  };

  return (
    <>
      <Helmet>
        <title>{t("meta.title")}</title>
      </Helmet>
      <StyledTabsWrapper>
        <StyledTabsHead className="tab-head">
          <h4 className="tab-head__title">
            {t("tabs.title")}
          </h4>
          <Tabs
            value={queryParams?.currentTab ?? DEFAULT_TAB}
            indicatorColor="secondary"
            onChange={handleChange}
            orientation="vertical"
            className="tab-head-buttons"
          >
            <Tab label={t("tabs.currency")} value="currency" />
            <Tab label={t("tabs.crypto")} value="crypto" />
          </Tabs>
        </StyledTabsHead>
        <StyledTabsBody className="tab-body">
          <TabPanel
            value={tabValue}
            index={0}
          >
            <RatesContainer type="currency" match={match} />
          </TabPanel>
          <TabPanel
            value={tabValue}
            index={1}
          >
            <RatesContainer type="crypto" match={match} />
          </TabPanel>
        </StyledTabsBody>
      </StyledTabsWrapper>
    </>
  );
};

export default RatesTabsContainer;
